import { createSlice } from '@reduxjs/toolkit';
import FJConstant from '../../constants/FJConstant.js';

export const AI_AUDIO_USE_CREDIT = 10;

export const FJSliceAIAudioGenerator = createSlice({
    name: 'AIAudioGenerator',
    initialState: {
        tabIndex: 0,
        incidentalAudioInfo: {}, // 参考配乐
        uploadIncidentalAudioStatus: FJConstant.DEFAULT,
        audioInfo: {}, // 参考音乐
        uploadAudioStatus: FJConstant.DEFAULT,
        vocalAudioInfo: {}, // 人声
        uploadVocalAudioStatus: FJConstant.DEFAULT,
        lyricContent: '',
        lyricDesc: '',
        presetList: [],
        sfxPresetList: [],
        insPresetList: [],
        referenceMusicList: [],
        referenceVocalList: [],
        instrumentalList: [],
        isGenerateLyricsLoading: false,
        isMultipleMode: false,
        isDraggingVoiceFile: false,
        prompt: '',
        historyTabIndex: 0,

        musicFreeNum: 0,
        intFreeNum: 0,
        sfxFreeNum: 0,
    },
    reducers: {
        setSliceMusicFreeNumCreationAction: (state, action) => {
            state.musicFreeNum = action.payload;
        },

        setSliceIntFreeNumCreationAction: (state, action) => {
            state.intFreeNum = action.payload;
        },
        setSliceSFXFreeNumCreationAction: (state, action) => {
            state.sfxFreeNum = action.payload;
        },

        setSliceSFXPresetList: (state, action) => {
            state.sfxPresetList = action.payload;
        },
        setSliceInsPresetList: (state, action) => {
            state.insPresetList = action.payload;
        },
        setSliceHistoryTabIndex: (state, action) => {
            state.historyTabIndex = action.payload;
        },
        setSlicePrompt: (state, action) => {
            state.prompt = action.payload;
        },
        setSliceIsMultipleMode: (state, action) => {
            state.isMultipleMode = action.payload;
        },
        setSliceIsGenerateLyricsLoading: (state, action) => {
            state.isGenerateLyricsLoading = action.payload;
        },
        setSliceIncidentalAudioInfo: (state, action) => {
            state.incidentalAudioInfo = action.payload;
        },
        setSliceAudioInfo: (state, action) => {
            state.audioInfo = action.payload;
        },
        setSliceVocalAudioInfo: (state, action) => {
            state.vocalAudioInfo = action.payload;
        },
        setSliceLyricContent: (state, action) => {
            state.lyricContent = action.payload;
        },
        setSliceLyricDesc: (state, action) => {
            state.lyricDesc = action.payload;
        },
        setSliceTabIndex: (state, action) => {
            state.tabIndex = action.payload;
        },
        setSliceUploadAudioStatus: (state, action) => {
            state.uploadAudioStatus = action.payload;
        },
        setSliceVocalUploadAudioStatus: (state, action) => {
            state.uploadVocalAudioStatus = action.payload;
        },
        setSliceIncidentalAudioStatus: (state, action) => {
            state.uploadIncidentalAudioStatus = action.payload;
        },
        setSlicePresetList: (state, action) => {
            state.presetList = action.payload;
        },
        setSliceReferenceMusicList: (state, action) => {
            state.referenceMusicList = action.payload;
        },
        setSliceReferenceVocalList: (state, action) => {
            state.referenceVocalList = action.payload;
        },
        setSliceInstrumentalList: (state, action) => {
            state.instrumentalList = action.payload;
        },
        setSliceIsDraggingVoiceFile: (state, action) => {
            state.isDraggingVoiceFile = action.payload;
        },
    },
});

export const {
    setSliceLyricDesc,
    setSliceTabIndex,
    setSliceLyricContent,
    setSliceIncidentalAudioInfo,
    setSliceAudioInfo,
    setSliceVocalAudioInfo,
    setSliceUploadAudioStatus,
    setSliceVocalUploadAudioStatus,
    setSliceIncidentalAudioStatus,
    setSlicePresetList,
    setSliceReferenceMusicList,
    setSliceReferenceVocalList,
    setSliceInstrumentalList,
    setSliceIsGenerateLyricsLoading,
    setSliceIsMultipleMode,
    setSliceIsDraggingVoiceFile,
    setSlicePrompt,
    setSliceHistoryTabIndex,
    setSliceSFXPresetList,
    setSliceInsPresetList,
    setSliceMusicFreeNumCreationAction,
    setSliceIntFreeNumCreationAction,
    setSliceSFXFreeNumCreationAction,
} = FJSliceAIAudioGenerator.actions;

export default FJSliceAIAudioGenerator.reducer;
